module.exports = __webpack_public_path__ + "img/career_support_logo_white.971e22df.svg";